import { AgendaButton } from "../../../styles/StyledMeeting";
import { Col, Row } from "react-grid-system";
import { Date } from "../../Date";
import { Link, useNavigate } from "react-router-dom";
import { PropTypes } from "prop-types";
import { StyledField } from "../../../styles/StyledField";
import { StyledMeetingCard } from "../../../styles/StyledMeetingsList";
import AgendaGreenIcon from "../../../assets/img/icons/agenda-green.svg";
import AgendaIcon from "../../../assets/img/icons/agenda.svg";
import ClockIcon from "../../../assets/img/icons/clock.svg";
import { default as convertStringToColor } from "../../../helpers/util/convertStringToColor";
import MinutesGreenIcon from "../../../assets/img/icons/minutes-green.svg";
import MinutesIcon from "../../../assets/img/icons/minutes.svg";
import moment from "moment";
import Moment from "react-moment";

export default function MeetingCard({ data }) {
	const navigate = useNavigate();
	const { id, title, startDate, endDate, place, organizationUnit, hasAgenda, hasMinutes } = data;

	let acronym = "";
	if (organizationUnit.name.split(" ").length > 1) {
		organizationUnit.name.split(" ").map((e, i) => {
			if (i < 2) acronym += e.split("")[0];
		});
	} else {
		organizationUnit.name.split("").map((e, i) => {
			if (i < 2) acronym += e;
		});
	}

	return (
		<StyledMeetingCard unitColor={convertStringToColor(acronym)}>
			<div className="main-info">
				<label>Meeting</label>
				<h4>{title}</h4>
				<Row>
					<Col sm={6}>
						<StyledField mb="6px">
							<label>Date</label>
							<Date>
								<Moment format="YYYY-MM-DD">{startDate}</Moment>
							</Date>
						</StyledField>
					</Col>
					<Col sm={6}>
						<StyledField mb="6px">
							<label>Time</label>
							<span>
								<img src={ClockIcon} alt="Clock icon" />
								{moment(startDate).format("HH:mm")}-{moment(endDate).format("HH:mm")}
							</span>
						</StyledField>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<StyledField mb="6px">
							<label>Place</label>
							<span>{place}</span>
						</StyledField>
					</Col>
				</Row>
			</div>
			<div className="unit">
				<div>
					<div className="icon">
						<span>{acronym}</span>
					</div>
					<span>Unit</span>
					<p>{organizationUnit.name}</p>
				</div>
			</div>
			<div className="agenda">
				<AgendaButton
					onClick={() => {
						if (hasAgenda) navigate(`/meetings/${id}?agenda=true`);
					}}
					active={hasAgenda}
				>
					Agenda
					<img src={hasAgenda ? AgendaGreenIcon : AgendaIcon} alt="Agenda icon" />
				</AgendaButton>
				<AgendaButton
					onClick={() => {
						if (hasMinutes) navigate(`/meetings/${id}?minutes=true`);
					}}
					active={hasMinutes}
				>
					Minutes
					<img src={hasMinutes ? MinutesGreenIcon : MinutesIcon} alt="Minutes icon" />
				</AgendaButton>
			</div>
			<Link to={`/meetings/${id}`}>Preview</Link>
		</StyledMeetingCard>
	);
}

MeetingCard.propTypes = {
	data: PropTypes.any,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
